module.exports = __webpack_public_path__ + "img/hitbtc.39192eb8.png";